module.exports = __webpack_public_path__ + "fonts/6c7c624a7d5b49a3136c0c658029c4ba.svg";